export default "__VITE_ASSET__w4KlWccu__"